// AUTO-GENERATED by scripts/generate-content.js from content.yaml.
// Do not edit this file directly — edit content.yaml instead.
const content = {
  "greeting": {
    "username": "Rakesh Seal",
    "title": "Hi, I'm Rakesh",
    "subTitle": "Senior Software Engineer at Keysight Technologies — building network traffic simulation, applied AI integrations, and AI security systems. IEEE Best Paper Award winner. Conference speaker at Nullcon, c0c0n, ROOTCON, and IEEE SVCC on TLS covert channels, AI agent attacks, and network security.",
    "resumeLink": "/resume.pdf",
    "displayGreeting": true
  },
  "socialMedia": {
    "github": "https://github.com/rakeshseal0",
    "linkedin": "https://www.linkedin.com/in/rakeshseal0/",
    "display": true
  },
  "skills": {
    "title": "What I do",
    "subTitle": "Senior Software Engineer working across network security, applied AI, and protocol research — shipping bi-weekly threat intelligence releases and speaking at international security conferences.",
    "display": true,
    "bullets": [
      "Build network traffic simulation and application threat intelligence systems deployed in bi-weekly ATI security releases.",
      "Integrate AI workflows into legacy products via plugin-based harnesses; evaluate model security through fine-tuning, backdoor, and poisoning scenarios.",
      "Research and publish on network security — covert channels, TLS exploitation, HTTP/3, and AI agent attacks.",
      "Speak at international security conferences (Nullcon, c0c0n, ROOTCON, IEEE SVCC) and train the security community at meetups.",
      "Drive bi-weekly ATI releases, develop internal productivity tools, and mentor interns and new engineers."
    ],
    "softwareSkills": [
      {
        "skillName": "Python",
        "fontAwesomeClassname": "fab fa-python"
      },
      {
        "skillName": "JavaScript",
        "fontAwesomeClassname": "fab fa-js"
      },
      {
        "skillName": "Ruby",
        "fontAwesomeClassname": "fas fa-gem"
      },
      {
        "skillName": "Node.js",
        "fontAwesomeClassname": "fab fa-node-js"
      },
      {
        "skillName": "Linux",
        "fontAwesomeClassname": "fab fa-linux"
      },
      {
        "skillName": "Docker",
        "fontAwesomeClassname": "fab fa-docker"
      },
      {
        "skillName": "Git",
        "fontAwesomeClassname": "fab fa-git-alt"
      },
      {
        "skillName": "Network Security",
        "fontAwesomeClassname": "fas fa-shield-alt"
      },
      {
        "skillName": "AI / ML",
        "fontAwesomeClassname": "fas fa-brain"
      }
    ]
  },
  "education": {
    "display": true,
    "schools": [
      {
        "schoolName": "Institute of Engineering & Management",
        "logo": "iemlogo.png",
        "subHeader": "B.Tech in Electronics and Communications Engineering (8.6 DGPA)",
        "duration": "August 2016 – August 2020",
        "desc": "Hands-on focus on hardware and software projects, hackathons, and technical leadership. Received the Director's Award for Best Scientific Mind at graduation.",
        "descBullets": [
          "Filed an Indian patent for a biometric smart electronic voting machine.",
          "First place in MAKAUT state-level robotics and AI exhibition (National Science Day).",
          "Top 10 robotic models at the Government of West Bengal Industry–Academia Conclave.",
          "Organised Maker Faire, Innovacion, and multiple technical seminars.",
          "Published a college research paper."
        ]
      }
    ]
  },
  "workExperiences": {
    "display": true,
    "experience": [
      {
        "role": "Senior Software Engineer",
        "company": "Keysight Technologies",
        "logo": "keysight-technologies--big.svg",
        "date": "June 2024 – Present",
        "desc": "Engineering and research in the Application and Threat Intelligence (ATI) team.",
        "descBullets": [
          "Built a plugin-based AI harness to control legacy product capabilities through AI-driven workflows.",
          "Worked on model fine-tuning and AI security evaluation including backdoor and poisoning scenarios.",
          "Developed HTTP/3 traffic-simulation capabilities; recognized with the Value Creator Award (January 2025).",
          "Built a Model Context Protocol (MCP) application-simulation framework for MCP traffic workloads.",
          "Drive bi-weekly ATI software releases, develop internal productivity tools, and mentor engineers.",
          "Engage with customers to investigate product issues, analyze network captures, and resolve failures."
        ]
      },
      {
        "role": "R&D Engineer II",
        "company": "Keysight Technologies",
        "logo": "keysight-technologies--big.svg",
        "date": "July 2022 – June 2024",
        "desc": "Led internal engineering projects and contributed to bi-weekly traffic-simulation releases.",
        "descBullets": [
          "Developed and managed WebExploder — a hybrid text/image-based web-crawling and traffic-capture tool.",
          "Built and maintained the C4 Framework for AI-generated domain-specific code in closed-source software.",
          "Contributed to 30+ intellectual property disclosures including 1 granted US Patent (US 11,876,686)."
        ]
      },
      {
        "role": "R&D Engineer I",
        "company": "Keysight Technologies",
        "logo": "keysight-technologies--big.svg",
        "date": "October 2020 – June 2022",
        "desc": "Joined full-time after internship, building automation tools and internal release infrastructure.",
        "descBullets": [
          "Built QuickGen — a PCAP-based traffic-generation and simulation automation tool actively used in development.",
          "Led delivery of ATI Meta Site, an internal release-data web portal (Keysight Spot Award, June 2022)."
        ]
      },
      {
        "role": "Head of Technical Operations",
        "company": "IEM IEDC",
        "logo": "iedc.jpeg",
        "date": "May 2019 – Oct 2020",
        "desc": "Led research operations at IEM's innovation lab funded by India's Dept. of Science & Technology. Guided student research projects and managed a team of ~40 student researchers."
      }
    ]
  },
  "achievements": {
    "title": "Achievements & Recognition 🏆",
    "subtitle": "Awards, patents, and recognition for engineering and security research contributions.",
    "display": true,
    "items": [
      {
        "title": "Best Paper Award — IEEE SVCC 2025",
        "subtitle": "HeLOL Tunnel: Covert Channel Exploitation of TLS Extensibility & Privacy Features. Co-authored with Dr. Reza Soosahabi. Published in IEEE proceedings, San Francisco.",
        "image": "awards/ieee-svcc.jpg",
        "links": [
          {
            "name": "IEEE Record",
            "url": "https://ieeexplore.ieee.org/document/11133623"
          },
          {
            "name": "Zenodo",
            "url": "https://zenodo.org/records/15315091"
          }
        ]
      },
      {
        "title": "Value Creator Award — Keysight (Jan 2025)",
        "subtitle": "Recognized for HTTP/3 traffic simulation engineering and network security performance testing contributions within the ATI team.",
        "image": "awards/value-creator.jpg",
        "links": []
      },
      {
        "title": "US Patent — US 11,876,686",
        "subtitle": "Methods, Systems, and Computer Readable Media for Conducting a Network Traffic Simulation Using HTTP Archive Data. Granted January 16, 2024. One of 30+ total IP contributions.",
        "image": "awards/uspto.jpg",
        "links": [
          {
            "name": "US Patent",
            "url": "https://patents.google.com/patent/US11876686B2/"
          }
        ]
      },
      {
        "title": "Keysight Spot Awards",
        "subtitle": "Received Keysight Spot Award twice — June 2022 for ATI Meta Site delivery and team management, and May 2021 for continuous contributions to existing and new projects.",
        "image": "awards/spotaward.jpeg",
        "links": []
      },
      {
        "title": "Director's Award for Best Scientific Mind",
        "subtitle": "Awarded by IEM for technical projects from ideation through execution, research publications, and organizing and speaking at technical seminars.",
        "image": "awards/director.jpg",
        "links": []
      },
      {
        "title": "National Science Day Exhibition — 1st Place",
        "subtitle": "Team placed first in the MAKAUT state-level robotics and AI exhibition on National Science Day.",
        "image": "awards/makaut.jpg",
        "links": []
      }
    ]
  },
  "talks": {
    "title": "Conference Talks",
    "subtitle": "International security conferences, technical presentations, and community training.",
    "display": true,
    "items": [
      {
        "title": "ROOTCON 25, Philippines",
        "subtitle": "Hijacking LLM based Agents",
        "image": "talks/rootcon.jpg",
        "links": [
          {
            "name": "Video",
            "url": "https://www.youtube.com/watch?v=7cYT99oXKX0&t=1662s"
          }
        ]
      },
      {
        "title": "Nullcon Goa 2026",
        "subtitle": "Just Say Hello: Stealthy Data Exfiltration Exploiting TLS Handshake with Next Generation Firewalls",
        "image": "talks/nullcon.jpg",
        "links": [
          {
            "name": "Talk Page",
            "url": "https://nullcon.net/talk/just-say-hello-stealthy-data-exfiltration-exploiting-tls-handshake-with-next-generation-firewalls/"
          },
          {
            "name": "Slides",
            "url": "https://nullcon.net/wp-content/uploads/2026/04/stealthy-data-exfiltration-exploiting-tls-handshake-with-next-generation-firewalls-goa26-1.pdf"
          }
        ]
      },
      {
        "title": "c0c0n 2025, Kochi",
        "subtitle": "Hijacking AI Agents: Attacks, Abuses, and How to Fight Back (with Anubhab Sahu & Diptisha Samanta)",
        "image": "talks/cocon2025.jpg",
        "links": [
          {
            "name": "Agenda",
            "url": "https://india.c0c0n.org/2025/agenda-10-11"
          }
        ]
      },
      {
        "title": "AI DevCon 2026, Bangalore",
        "subtitle": "Zero Trust for Agentic AI",
        "image": "talks/aidevcon.jpg",
        "links": [
          {
            "name": "Conference",
            "url": "https://www.aidevcon.in/#"
          }
        ]
      },
      {
        "title": "c0c0n 2024, Ahmedabad",
        "subtitle": "Ride on the House: Exploiting Public Transport Ticketing Systems for Free Rides (with Diptisha Samanta)",
        "image": "talks/cocon24.jpg",
        "links": [
          {
            "name": "Speakers",
            "url": "https://india.c0c0n.org/2024/speakers"
          }
        ]
      },
      {
        "title": "ICETCSDP 2026",
        "subtitle": "Network Security with JA3 Fingerprinting",
        "image": "talks/icetcsdp.jpg",
        "links": [
          {
            "name": "Conference",
            "url": "https://icetcsdp.msit.edu.in/"
          }
        ]
      },
      {
        "title": "Keysight Technical Conference, San Francisco 2025",
        "subtitle": "C4 Framework: AI-generated domain-specific code for closed-source software development",
        "image": "talks/ktc-sfo.jpg",
        "links": []
      },
      {
        "title": "Null/OWASP Kolkata Chapter",
        "subtitle": "8x community talks — DNS Attacks, JA3 Network Security, Docker Security, and Ticketing System Exploitation",
        "image": "talks/nullmeet2.jpeg",
        "links": [
          {
            "name": "Community",
            "url": "https://null.community/"
          }
        ]
      }
    ]
  },
  "blogs": {
    "title": "Blogs",
    "subtitle": "Writing about network security, protocol research, and engineering — published on Keysight and Medium.",
    "display": true,
    "displayMediumBlogs": false,
    "items": [
      {
        "url": "https://www.keysight.com/blogs/en/tech/nwvs/2024/01/03/dga-blog",
        "title": "How Domain Generation Algorithms Impact Network Security",
        "description": "In-depth guide to DGA — how domain generation algorithms are used by malware and how to detect them."
      },
      {
        "url": "https://www.keysight.com/blogs/en/tech/nwvs/2024/06/26/ja3-randomization",
        "title": "Enhancing Network Security with JA3",
        "description": "How JA3 fingerprinting works in network security and what randomization means for detection."
      },
      {
        "url": "https://blogs.keysight.com/blogs/tech/nwvs.entry.html/2021/07/17/looking_into_quicpa-pUtF.html",
        "title": "Looking Into QUIC Packets in your Network",
        "description": "Detailed guide about encryption of TLS packets in the QUIC protocol."
      },
      {
        "url": "https://www.keysight.com/blogs/en/tech/nwvs/2023/01/31/krpc-protocol-the-language-of-torrent-peers",
        "title": "KRPC Protocol: The Language of Torrent Peers",
        "description": "A detailed explanation of the KRPC protocol used by BitTorrent peers for DHT communication."
      },
      {
        "url": "https://blogs.keysight.com/blogs/tech/nwvs.entry.html/2022/05/27/a_comprehensive_guideonharfiles-y4dm.html",
        "title": "A Comprehensive Guide on HAR Files",
        "description": "In-depth guide on HTTP Archive (HAR) files and their contents for network traffic analysis."
      },
      {
        "url": "https://medium.com/@rakeshseal3/flask-celery-ultimate-guide-no-bs-cafd0ea75649",
        "title": "Flask + Celery Ultimate Guide — No BS",
        "description": "Practical guide to async task processing with Celery and Python Flask."
      }
    ]
  },
  "contact": {
    "title": "Contact Me ☎️",
    "subtitle": "Discuss a project, collaboration, or just want to say hi? My inbox is open.",
    "number": "+91-9733028233",
    "email": "rakeshseal0@gmail.com"
  },
  "typewriter": {
    "rows": [
      {
        "label": "role",
        "value": "Senior R&D Engineer, Keysight ATI"
      },
      {
        "label": "focus",
        "value": "AI Security · Network Security"
      },
      {
        "label": "builds",
        "value": "AI FDE · Full-Stack Developer"
      },
      {
        "label": "talks",
        "value": "ROOTCON · Nullcon · c0c0n"
      },
      {
        "label": "award",
        "value": "IEEE Best Paper — SVCC 2025",
        "gold": true
      }
    ],
    "stats": [
      {
        "num": "6+",
        "label": "Years",
        "href": "#experience"
      },
      {
        "num": "30+",
        "label": "Intellectual Property",
        "href": "#achievements"
      },
      {
        "num": "10+",
        "label": "Talks",
        "href": "#talks"
      },
      {
        "num": "1",
        "label": "Patent",
        "href": "#achievements"
      }
    ]
  }
};

export default content;
